/**
 * FingerprintJS Open Source integration
 *
 * Used for duplicate vote detection without storing identifiable data.
 */

import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise: Promise<string> | null = null;

/**
 * Get the browser fingerprint
 *
 * Uses FingerprintJS Open Source which provides ~60-70% accuracy.
 * The fingerprint is hashed server-side with a daily salt before storage.
 */
export async function getFingerprint(): Promise<string> {
  if (!fpPromise) {
    fpPromise = (async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        return result.visitorId;
      } catch (error) {
        console.error('Failed to get fingerprint:', error);
        // Fallback to a random ID if fingerprinting fails
        // This means the user could vote multiple times, but it's better than blocking
        return `fallback-${crypto.randomUUID()}`;
      }
    })();
  }

  return fpPromise;
}

/**
 * Clear cached fingerprint (for testing)
 */
export function clearFingerprintCache(): void {
  fpPromise = null;
}
